import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from "@material-ui/core";
import Chart from "chart.js";
import React, { useEffect, useRef } from "react";
import { PROGRESS_TYPE_LABELS } from "utils/jobDetailsUtils";

interface EstimatedProgressChartProps {
  currentDays: number;
  progress: number;
  totalDays: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: theme.palette.primary.dark,
    },
    labelDays: {
      color: theme.palette.primary.dark,
      fontWeight: 600,
    },
    percentage: {
      color: theme.palette.primary.dark,
      fontWeight: 600,
      marginBottom: "4px",
    },
  }),
);

export function TimeProgressChart({
  currentDays,
  progress,
  totalDays,
}: EstimatedProgressChartProps) {
  const chartCanvasRef = useRef({} as HTMLCanvasElement);
  const classes = useStyles();
  const theme = useTheme();

  useEffect(() => {
    const isOvertime = progress > 100.0;

    new Chart(chartCanvasRef.current, {
      data: {
        datasets: [
          {
            backgroundColor: isOvertime
              ? theme.palette.error.main
              : [theme.palette.primary.light, theme.palette.grey[200]],
            borderWidth: 0,
            data: isOvertime ? [progress] : [progress, 100.0 - progress],
            label: PROGRESS_TYPE_LABELS.TIME,
          },
        ],
      },
      options: {
        animation: {
          animateRotate: true,
        },
        aspectRatio: 1,
        cutoutPercentage: 85,
        hover: {
          mode: undefined,
        },
        tooltips: {
          enabled: false,
        },
      },
      type: "doughnut",
    });
  }, [progress, theme]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      margin="0 auto"
      maxWidth="175px"
      position="relative"
    >
      <canvas ref={chartCanvasRef} />
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        height="50%"
        justifyContent="center"
        left="22%"
        position="absolute"
        top="25%"
        width="56%"
      >
        <Typography
          className={classes.percentage}
          variant="h5"
        >{`${progress}%`}</Typography>
        <Typography align="center" className={classes.label} variant="body2">
          {PROGRESS_TYPE_LABELS.TIME}
        </Typography>
        <Typography
          align="center"
          className={classes.labelDays}
          variant="body2"
        >
          {`Days ${currentDays}/${totalDays}`}
        </Typography>
      </Box>
    </Box>
  );
}
